var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{attrs:{"type":"success","prominent":"","dense":"","dismissible":"","border":"left","value":_vm.flag},on:{"input":_vm.onInput}},[_c('strong',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }